import React, { useState } from "react";
import {
  Box,
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  TablePagination,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Grid,
  InputAdornment,
  Chip,
  Tooltip,
  Alert,
  Card,
  CardContent,
  Avatar,
  Tabs,
  Tab,
  Divider,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Badge,
  Stepper,
  Step,
  StepLabel,
  LinearProgress,
} from "@mui/material";
import {
  Search as SearchIcon,
  Refresh as RefreshIcon,
  VerifiedUser as VerifiedIcon,
  HourglassEmpty as PendingIcon,
  Cancel as RejectedIcon,
  Visibility as ViewIcon,
  CheckCircle as ApproveIcon,
  Close as RejectIcon,
  Description as DocumentIcon,
  CreditCard as PanIcon,
  Fingerprint as AadharIcon,
  Business as GstIcon,
  AccountBalance as BankIcon,
  CloudUpload as UploadIcon,
  Download as DownloadIcon,
  Comment as CommentIcon,
  History as HistoryIcon,
  Person as PersonIcon,
  Phone as PhoneIcon,
  Email as EmailIcon,
  Info as InfoIcon,
  Warning as WarningIcon,
  CheckCircleOutline as CheckIcon,
  Assignment as AssignIcon,
} from "@mui/icons-material";

const KYCVerification = () => {
  const [activeTab, setActiveTab] = useState(0);

  // Sample KYC data
  const [kycRecords, setKycRecords] = useState([
    {
      id: 1,
      partnerId: "PTR001",
      partnerName: "Suresh ",
      ownerName: "Suresh Kumar",
      phone: "+91 98765 43210",
      email: "suresh@.com",
      submissionDate: "2024-01-15",
      verificationDate: "2024-01-16",
      verifiedBy: "Admin User",
      status: "Verified",
      documents: {
        pan: { uploaded: true, verified: true, remarks: "Valid PAN card", fileName: "pan_suresh.pdf" },
        aadhar: { uploaded: true, verified: true, remarks: "Valid Aadhar card", fileName: "aadhar_suresh.pdf" },
        gst: { uploaded: true, verified: true, remarks: "Valid GST certificate", fileName: "gst_suresh.pdf" },
        bank: { uploaded: true, verified: true, remarks: "Valid cancelled cheque", fileName: "cheque_suresh.pdf" },
      },
      panNumber: "ABCDE1234F",
      aadharNumber: "XXXX-XXXX-1234",
      gstNumber: "27AAAAA0000A1Z5",
      bankAccount: "1234567890",
      ifscCode: "SBIN0001234",
    },
    {
      id: 2,
      partnerId: "PTR002",
      partnerName: "Tech Solutions Hub",
      ownerName: "Priya Sharma",
      phone: "+91 98765 43211",
      email: "priya@techsolutions.com",
      submissionDate: "2024-01-18",
      verificationDate: null,
      verifiedBy: null,
      status: "Pending",
      documents: {
        pan: { uploaded: true, verified: false, remarks: "", fileName: "pan_priya.pdf" },
        aadhar: { uploaded: true, verified: false, remarks: "", fileName: "aadhar_priya.pdf" },
        gst: { uploaded: true, verified: false, remarks: "", fileName: "gst_priya.pdf" },
        bank: { uploaded: true, verified: false, remarks: "", fileName: "cheque_priya.pdf" },
      },
      panNumber: "XYZAB5678C",
      aadharNumber: "XXXX-XXXX-5678",
      gstNumber: "29BBBBB0000B1Z5",
      bankAccount: "9876543210",
      ifscCode: "HDFC0002345",
    },
    {
      id: 3,
      partnerId: "PTR003",
      partnerName: "Digital Commerce Pro",
      ownerName: "Amit Patel",
      phone: "+91 98765 43212",
      email: "amit@digitalcommerce.com",
      submissionDate: "2024-01-10",
      verificationDate: "2024-01-12",
      verifiedBy: "Admin User",
      status: "Verified",
      documents: {
        pan: { uploaded: true, verified: true, remarks: "Verified", fileName: "pan_amit.pdf" },
        aadhar: { uploaded: true, verified: true, remarks: "Verified", fileName: "aadhar_amit.pdf" },
        gst: { uploaded: true, verified: true, remarks: "Verified", fileName: "gst_amit.pdf" },
        bank: { uploaded: true, verified: true, remarks: "Verified", fileName: "cheque_amit.pdf" },
      },
      panNumber: "PQRST9876D",
      aadharNumber: "XXXX-XXXX-9876",
      gstNumber: "24CCCCC0000C1Z5",
      bankAccount: "1122334455",
      ifscCode: "ICIC0003456",
    },
    {
      id: 4,
      partnerId: "PTR005",
      partnerName: "Sales Force India",
      ownerName: "Vikram Singh",
      phone: "+91 98765 43214",
      email: "vikram@salesforce.com",
      submissionDate: "2024-01-20",
      verificationDate: null,
      verifiedBy: null,
      status: "Pending",
      documents: {
        pan: { uploaded: true, verified: false, remarks: "", fileName: "pan_vikram.pdf" },
        aadhar: { uploaded: true, verified: false, remarks: "", fileName: "aadhar_vikram.pdf" },
        gst: { uploaded: false, verified: false, remarks: "", fileName: null },
        bank: { uploaded: true, verified: false, remarks: "", fileName: "cheque_vikram.pdf" },
      },
      panNumber: "LMNOP4567E",
      aadharNumber: "XXXX-XXXX-4567",
      gstNumber: "",
      bankAccount: "5566778899",
      ifscCode: "AXIS0004567",
    },
    {
      id: 5,
      partnerId: "PTR006",
      partnerName: "Global Retail Partners",
      ownerName: "Rahul Mehta",
      phone: "+91 98765 43215",
      email: "rahul@globalretail.com",
      submissionDate: "2024-01-12",
      verificationDate: "2024-01-14",
      verifiedBy: "Verification Team",
      status: "Rejected",
      documents: {
        pan: { uploaded: true, verified: false, remarks: "PAN number mismatch", fileName: "pan_rahul.pdf" },
        aadhar: { uploaded: true, verified: false, remarks: "Unclear image", fileName: "aadhar_rahul.pdf" },
        gst: { uploaded: true, verified: true, remarks: "Valid", fileName: "gst_rahul.pdf" },
        bank: { uploaded: true, verified: false, remarks: "Account name mismatch", fileName: "cheque_rahul.pdf" },
      },
      panNumber: "INVALID123",
      aadharNumber: "XXXX-XXXX-1111",
      gstNumber: "33EEEEE0000E1Z5",
      bankAccount: "9988776655",
      ifscCode: "PNB0005678",
    },
  ]);

  const [searchQuery, setSearchQuery] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [successMessage, setSuccessMessage] = useState("");
  const [openViewModal, setOpenViewModal] = useState(false);
  const [viewingRecord, setViewingRecord] = useState(null);
  const [openRejectModal, setOpenRejectModal] = useState(false);
  const [rejectRemarks, setRejectRemarks] = useState("");
  const [selectedRecord, setSelectedRecord] = useState(null);

  // Helper functions
  const getFilteredRecords = () => {
    let filtered = kycRecords;

    if (searchQuery) {
      filtered = filtered.filter((record) =>
        Object.values(record).some((value) =>
          String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
      );
    }

    if (statusFilter !== "all") {
      filtered = filtered.filter((r) => r.status === statusFilter);
    }

    if (activeTab === 1) {
      filtered = filtered.filter((r) => r.status === "Pending");
    } else if (activeTab === 2) {
      filtered = filtered.filter((r) => r.status === "Verified");
    } else if (activeTab === 3) {
      filtered = filtered.filter((r) => r.status === "Rejected");
    }

    return filtered;
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'Verified': return { bg: '#e8f5e9', color: '#2e7d32' };
      case 'Pending': return { bg: '#fff3e0', color: '#e65100' };
      case 'Rejected': return { bg: '#ffebee', color: '#d32f2f' };
      default: return { bg: '#f5f5f5', color: '#666' };
    }
  };

  const getDocumentIcon = (docType) => {
    switch (docType) {
      case 'pan': return <PanIcon />;
      case 'aadhar': return <AadharIcon />;
      case 'gst': return <GstIcon />;
      case 'bank': return <BankIcon />;
      default: return <DocumentIcon />;
    }
  };

  const getDocumentLabel = (docType) => {
    switch (docType) {
      case 'pan': return 'PAN Card';
      case 'aadhar': return 'Aadhar Card';
      case 'gst': return 'GST Certificate';
      case 'bank': return 'Cancelled Cheque';
      default: return 'Document';
    }
  };

  const calculateCompletionPercentage = (documents) => {
    const totalDocs = 4;
    const uploadedDocs = Object.values(documents).filter(doc => doc.uploaded).length;
    return (uploadedDocs / totalDocs) * 100;
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });
  };

  // Handlers
  const handleView = (record) => {
    setViewingRecord(record);
    setOpenViewModal(true);
  };

  const handleApprove = (record) => {
    setKycRecords(kycRecords.map(r =>
      r.id === record.id
        ? {
          ...r,
          status: 'Verified',
          verificationDate: new Date().toISOString().split('T')[0],
          verifiedBy: 'Admin User',
          documents: {
            pan: { ...r.documents.pan, verified: true, remarks: 'Verified' },
            aadhar: { ...r.documents.aadhar, verified: true, remarks: 'Verified' },
            gst: { ...r.documents.gst, verified: true, remarks: 'Verified' },
            bank: { ...r.documents.bank, verified: true, remarks: 'Verified' },
          }
        }
        : r
    ));
    setSuccessMessage(`KYC for ${record.partnerName} approved successfully!`);
    setTimeout(() => setSuccessMessage(""), 3000);
    setOpenViewModal(false);
  };

  const handleReject = (record) => {
    setSelectedRecord(record);
    setOpenRejectModal(true);
  };

  const handleConfirmReject = () => {
    if (!rejectRemarks.trim()) {
      alert("Please provide rejection remarks");
      return;
    }

    setKycRecords(kycRecords.map(r =>
      r.id === selectedRecord.id
        ? {
          ...r,
          status: 'Rejected',
          verificationDate: new Date().toISOString().split('T')[0],
          verifiedBy: 'Admin User',
        }
        : r
    ));
    setSuccessMessage(`KYC for ${selectedRecord.partnerName} rejected!`);
    setTimeout(() => setSuccessMessage(""), 3000);
    setOpenRejectModal(false);
    setOpenViewModal(false);
    setRejectRemarks("");
  };

  const handleChangePage = (_, newPage) => setPage(newPage);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSearch = () => {
    setPage(0);
    setSuccessMessage(`Search completed. Found ${getFilteredRecords().length} records.`);
    setTimeout(() => setSuccessMessage(""), 3000);
  };

  const handleReset = () => {
    setSearchQuery("");
    setStatusFilter("all");
    setPage(0);
    setSuccessMessage("");
  };

  const filteredRecords = getFilteredRecords();

  // Calculate statistics
  const totalRecords = kycRecords.length;
  const pendingRecords = kycRecords.filter(r => r.status === "Pending").length;
  const verifiedRecords = kycRecords.filter(r => r.status === "Verified").length;
  const rejectedRecords = kycRecords.filter(r => r.status === "Rejected").length;

  return (
    <Box sx={{ p: 3 }}>
      {/* Header Section */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <VerifiedIcon sx={{ color: 'primary.main', fontSize: 40 }} />
          <Box>
            <Typography variant="h4" fontWeight="bold" color="primary">
              KYC Verification
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Verify partner documents and approve KYC • {filteredRecords.length} records
            </Typography>
          </Box>
        </Box>
        <Box sx={{ display: 'flex', gap: 2 }}>
          <Button
            variant="outlined"
            startIcon={<HistoryIcon />}
            sx={{ borderRadius: 2 }}
          >
            Verification History
          </Button>
        </Box>
      </Box>

      {/* Success Message */}
      {successMessage && (
        <Alert severity="success" sx={{ mb: 2, borderRadius: 2 }}>
          {successMessage}
        </Alert>
      )}

      {/* Statistics Cards */}
      <Grid container spacing={3} sx={{ mb: 3 }}>
        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ borderRadius: 2, boxShadow: 2, borderLeft: '4px solid #1976d2' }}>
            <CardContent>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Box>
                  <Typography variant="caption" color="text.secondary">Total Submissions</Typography>
                  <Typography variant="h4" fontWeight="bold" color="primary.main">
                    {totalRecords}
                  </Typography>
                </Box>
                <DocumentIcon sx={{ fontSize: 48, color: 'primary.main', opacity: 0.3 }} />
              </Box>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ borderRadius: 2, boxShadow: 2, borderLeft: '4px solid #ff9800' }}>
            <CardContent>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Box>
                  <Typography variant="caption" color="text.secondary">Pending Review</Typography>
                  <Typography variant="h4" fontWeight="bold" color="warning.main">
                    {pendingRecords}
                  </Typography>
                </Box>
                <PendingIcon sx={{ fontSize: 48, color: 'warning.main', opacity: 0.3 }} />
              </Box>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ borderRadius: 2, boxShadow: 2, borderLeft: '4px solid #2e7d32' }}>
            <CardContent>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Box>
                  <Typography variant="caption" color="text.secondary">Verified</Typography>
                  <Typography variant="h4" fontWeight="bold" color="success.main">
                    {verifiedRecords}
                  </Typography>
                </Box>
                <ApproveIcon sx={{ fontSize: 48, color: 'success.main', opacity: 0.3 }} />
              </Box>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ borderRadius: 2, boxShadow: 2, borderLeft: '4px solid #d32f2f' }}>
            <CardContent>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Box>
                  <Typography variant="caption" color="text.secondary">Rejected</Typography>
                  <Typography variant="h4" fontWeight="bold" color="error.main">
                    {rejectedRecords}
                  </Typography>
                </Box>
                <RejectedIcon sx={{ fontSize: 48, color: 'error.main', opacity: 0.3 }} />
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Tabs */}
      <Paper sx={{ mb: 3, borderRadius: 2 }}>
        <Tabs
          value={activeTab}
          onChange={(e, newValue) => setActiveTab(newValue)}
          sx={{ borderBottom: 1, borderColor: 'divider' }}
        >
          <Tab
            label={<Badge badgeContent={totalRecords} color="primary">All Records</Badge>}
            icon={<DocumentIcon />}
            iconPosition="start"
          />
          <Tab
            label={<Badge badgeContent={pendingRecords} color="warning">Pending</Badge>}
            icon={<PendingIcon />}
            iconPosition="start"
          />
          <Tab
            label={<Badge badgeContent={verifiedRecords} color="success">Verified</Badge>}
            icon={<VerifiedIcon />}
            iconPosition="start"
          />
          <Tab
            label={<Badge badgeContent={rejectedRecords} color="error">Rejected</Badge>}
            icon={<RejectedIcon />}
            iconPosition="start"
          />
        </Tabs>
      </Paper>

      {/* Search and Filter Section */}
      <Paper sx={{ p: 3, mb: 3, borderRadius: 2, boxShadow: 2 }}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} md={5}>
            <TextField
              fullWidth
              label="Search by Partner Name, ID, or Contact..."
              variant="outlined"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <FormControl fullWidth>
              <InputLabel>Status</InputLabel>
              <Select
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
                label="Status"
              >
                <MenuItem value="all">All Status</MenuItem>
                <MenuItem value="Pending">Pending</MenuItem>
                <MenuItem value="Verified">Verified</MenuItem>
                <MenuItem value="Rejected">Rejected</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={4}>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <Button variant="contained" onClick={handleSearch} startIcon={<SearchIcon />} sx={{ flex: 1 }}>
                Search
              </Button>
              <Button variant="outlined" onClick={handleReset} startIcon={<RefreshIcon />} sx={{ flex: 1 }}>
                Reset
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Paper>

      {/* Table Section */}
      <Paper sx={{ borderRadius: 2, boxShadow: 3, overflow: 'hidden' }}>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow sx={{ backgroundColor: '#f8f9fa' }}>
                <TableCell sx={{ fontWeight: 'bold' }}>Partner Details</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Contact</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Documents</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Submission Date</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Status</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Verified By</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }} align="center">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredRecords.length > 0 ? (
                filteredRecords.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((record) => {
                  const statusStyle = getStatusColor(record.status);
                  const completion = calculateCompletionPercentage(record.documents);
                  return (
                    <TableRow key={record.id} sx={{ '&:hover': { backgroundColor: '#f5f5f5' } }}>
                      <TableCell>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                          <Avatar sx={{ bgcolor: 'primary.main', width: 40, height: 40 }}>
                            {record.partnerName.charAt(0)}
                          </Avatar>
                          <Box>
                            <Typography variant="body2" fontWeight="700">{record.partnerName}</Typography>
                            <Typography variant="caption" color="text.secondary" sx={{ fontFamily: 'monospace' }}>
                              {record.partnerId}
                            </Typography>
                            <Typography variant="caption" color="text.secondary" display="block">
                              {record.ownerName}
                            </Typography>
                          </Box>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box>
                          <Typography variant="caption" display="flex" alignItems="center" sx={{ mb: 0.5 }}>
                            <PhoneIcon sx={{ fontSize: 14, mr: 0.5 }} />
                            {record.phone}
                          </Typography>
                          <Typography variant="caption" display="flex" alignItems="center">
                            <EmailIcon sx={{ fontSize: 14, mr: 0.5 }} />
                            {record.email.substring(0, 20)}...
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box>
                          <Box sx={{ display: 'flex', gap: 0.5, mb: 0.5 }}>
                            {Object.entries(record.documents).map(([key, doc]) => (
                              <Tooltip key={key} title={`${getDocumentLabel(key)}: ${doc.uploaded ? 'Uploaded' : 'Not Uploaded'}`}>
                                <Chip
                                  icon={getDocumentIcon(key)}
                                  label={key.toUpperCase()}
                                  size="small"
                                  sx={{
                                    height: 24,
                                    fontSize: '0.65rem',
                                    bgcolor: doc.uploaded ? (doc.verified ? '#e8f5e9' : '#fff3e0') : '#ffebee',
                                    color: doc.uploaded ? (doc.verified ? '#2e7d32' : '#e65100') : '#d32f2f',
                                  }}
                                />
                              </Tooltip>
                            ))}
                          </Box>
                          <LinearProgress
                            variant="determinate"
                            value={completion}
                            sx={{ height: 4, borderRadius: 1 }}
                            color={completion === 100 ? 'success' : 'warning'}
                          />
                          <Typography variant="caption" color="text.secondary">
                            {completion}% Complete
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2">{formatDate(record.submissionDate)}</Typography>
                      </TableCell>
                      <TableCell>
                        <Chip
                          label={record.status}
                          size="small"
                          sx={{
                            backgroundColor: statusStyle.bg,
                            color: statusStyle.color,
                            fontWeight: 600,
                            mb: 0.5,
                          }}
                        />
                        {record.verificationDate && (
                          <Typography variant="caption" color="text.secondary" display="block">
                            {formatDate(record.verificationDate)}
                          </Typography>
                        )}
                      </TableCell>
                      <TableCell>
                        <Typography variant="caption">{record.verifiedBy || 'N/A'}</Typography>
                      </TableCell>
                      <TableCell align="center">
                        <Tooltip title="View & Verify">
                          <IconButton
                            size="small"
                            onClick={() => handleView(record)}
                            sx={{ color: 'primary.main' }}
                          >
                            <ViewIcon />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  );
                })
              ) : (
                <TableRow>
                  <TableCell colSpan={7} align="center" sx={{ py: 4 }}>
                    <DocumentIcon sx={{ fontSize: 48, color: 'text.disabled', mb: 1 }} />
                    <Typography variant="body1" color="text.secondary">No KYC records found</Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          component="div"
          count={filteredRecords.length}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[5, 10, 25, 50]}
        />
      </Paper>

      {/* View & Verify Modal */}
      <Dialog open={openViewModal} onClose={() => setOpenViewModal(false)} maxWidth="lg" fullWidth>
        <DialogTitle sx={{
          backgroundColor: 'primary.main',
          color: 'white',
        }}>
          <Typography variant="h6" sx={{ color: 'white', display: 'flex', alignItems: 'center', gap: 1 }}>
            <VerifiedIcon /> KYC Verification - {viewingRecord?.partnerName}
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ mt: 2 }}>
          {viewingRecord && (
            <Grid container spacing={3}>
              {/* Partner Info */}
              <Grid item xs={12}>
                <Paper sx={{ p: 2, bgcolor: '#f5f5f5' }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={3}>
                      <Typography variant="caption" color="text.secondary">Partner Code</Typography>
                      <Typography variant="body1" fontWeight="600" sx={{ fontFamily: 'monospace' }}>
                        {viewingRecord.partnerId}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <Typography variant="caption" color="text.secondary">Owner Name</Typography>
                      <Typography variant="body1" fontWeight="600">{viewingRecord.ownerName}</Typography>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <Typography variant="caption" color="text.secondary">Phone</Typography>
                      <Typography variant="body1" fontWeight="600">{viewingRecord.phone}</Typography>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <Typography variant="caption" color="text.secondary">Email</Typography>
                      <Typography variant="body1" fontWeight="600">{viewingRecord.email}</Typography>
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>

              {/* Document Verification */}
              <Grid item xs={12}>
                <Typography variant="h6" fontWeight="bold" gutterBottom>
                  Document Verification
                </Typography>
                <Divider sx={{ mb: 2 }} />
              </Grid>

              {/* PAN Card */}
              <Grid item xs={12} md={6}>
                <Card sx={{ borderRadius: 2, border: viewingRecord.documents.pan.verified ? '2px solid #2e7d32' : '2px solid #ccc' }}>
                  <CardContent>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <PanIcon sx={{ color: 'primary.main', fontSize: 28 }} />
                        <Typography variant="subtitle1" fontWeight="bold">PAN Card</Typography>
                      </Box>
                      {viewingRecord.documents.pan.verified && (
                        <Chip label="Verified" size="small" color="success" icon={<CheckIcon />} />
                      )}
                    </Box>
                    <Typography variant="caption" color="text.secondary">PAN Number</Typography>
                    <Typography variant="body1" fontWeight="600" sx={{ fontFamily: 'monospace', mb: 1 }}>
                      {viewingRecord.panNumber}
                    </Typography>
                    {viewingRecord.documents.pan.uploaded ? (
                      <>
                        <Typography variant="caption" color="text.secondary">File: {viewingRecord.documents.pan.fileName}</Typography>
                        <Box sx={{ mt: 2, display: 'flex', gap: 1 }}>
                          <Button size="small" startIcon={<ViewIcon />} variant="outlined" fullWidth>
                            View Document
                          </Button>
                          <Button size="small" startIcon={<DownloadIcon />} variant="outlined">
                            Download
                          </Button>
                        </Box>
                        {viewingRecord.documents.pan.remarks && (
                          <Alert severity={viewingRecord.documents.pan.verified ? "success" : "warning"} sx={{ mt: 2 }}>
                            {viewingRecord.documents.pan.remarks}
                          </Alert>
                        )}
                      </>
                    ) : (
                      <Alert severity="error" sx={{ mt: 1 }}>Not Uploaded</Alert>
                    )}
                  </CardContent>
                </Card>
              </Grid>

              {/* Aadhar Card */}
              <Grid item xs={12} md={6}>
                <Card sx={{ borderRadius: 2, border: viewingRecord.documents.aadhar.verified ? '2px solid #2e7d32' : '2px solid #ccc' }}>
                  <CardContent>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <AadharIcon sx={{ color: 'secondary.main', fontSize: 28 }} />
                        <Typography variant="subtitle1" fontWeight="bold">Aadhar Card</Typography>
                      </Box>
                      {viewingRecord.documents.aadhar.verified && (
                        <Chip label="Verified" size="small" color="success" icon={<CheckIcon />} />
                      )}
                    </Box>
                    <Typography variant="caption" color="text.secondary">Aadhar Number</Typography>
                    <Typography variant="body1" fontWeight="600" sx={{ fontFamily: 'monospace', mb: 1 }}>
                      {viewingRecord.aadharNumber}
                    </Typography>
                    {viewingRecord.documents.aadhar.uploaded ? (
                      <>
                        <Typography variant="caption" color="text.secondary">File: {viewingRecord.documents.aadhar.fileName}</Typography>
                        <Box sx={{ mt: 2, display: 'flex', gap: 1 }}>
                          <Button size="small" startIcon={<ViewIcon />} variant="outlined" fullWidth>
                            View Document
                          </Button>
                          <Button size="small" startIcon={<DownloadIcon />} variant="outlined">
                            Download
                          </Button>
                        </Box>
                        {viewingRecord.documents.aadhar.remarks && (
                          <Alert severity={viewingRecord.documents.aadhar.verified ? "success" : "warning"} sx={{ mt: 2 }}>
                            {viewingRecord.documents.aadhar.remarks}
                          </Alert>
                        )}
                      </>
                    ) : (
                      <Alert severity="error" sx={{ mt: 1 }}>Not Uploaded</Alert>
                    )}
                  </CardContent>
                </Card>
              </Grid>

              {/* GST Certificate */}
              <Grid item xs={12} md={6}>
                <Card sx={{ borderRadius: 2, border: viewingRecord.documents.gst.verified ? '2px solid #2e7d32' : '2px solid #ccc' }}>
                  <CardContent>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <GstIcon sx={{ color: 'warning.main', fontSize: 28 }} />
                        <Typography variant="subtitle1" fontWeight="bold">GST Certificate</Typography>
                      </Box>
                      {viewingRecord.documents.gst.verified && (
                        <Chip label="Verified" size="small" color="success" icon={<CheckIcon />} />
                      )}
                    </Box>
                    <Typography variant="caption" color="text.secondary">GST Number</Typography>
                    <Typography variant="body1" fontWeight="600" sx={{ fontFamily: 'monospace', mb: 1 }}>
                      {viewingRecord.gstNumber || 'N/A'}
                    </Typography>
                    {viewingRecord.documents.gst.uploaded ? (
                      <>
                        <Typography variant="caption" color="text.secondary">File: {viewingRecord.documents.gst.fileName}</Typography>
                        <Box sx={{ mt: 2, display: 'flex', gap: 1 }}>
                          <Button size="small" startIcon={<ViewIcon />} variant="outlined" fullWidth>
                            View Document
                          </Button>
                          <Button size="small" startIcon={<DownloadIcon />} variant="outlined">
                            Download
                          </Button>
                        </Box>
                        {viewingRecord.documents.gst.remarks && (
                          <Alert severity={viewingRecord.documents.gst.verified ? "success" : "warning"} sx={{ mt: 2 }}>
                            {viewingRecord.documents.gst.remarks}
                          </Alert>
                        )}
                      </>
                    ) : (
                      <Alert severity="warning" sx={{ mt: 1 }}>Optional - Not Uploaded</Alert>
                    )}
                  </CardContent>
                </Card>
              </Grid>

              {/* Bank Details */}
              <Grid item xs={12} md={6}>
                <Card sx={{ borderRadius: 2, border: viewingRecord.documents.bank.verified ? '2px solid #2e7d32' : '2px solid #ccc' }}>
                  <CardContent>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <BankIcon sx={{ color: 'info.main', fontSize: 28 }} />
                        <Typography variant="subtitle1" fontWeight="bold">Cancelled Cheque</Typography>
                      </Box>
                      {viewingRecord.documents.bank.verified && (
                        <Chip label="Verified" size="small" color="success" icon={<CheckIcon />} />
                      )}
                    </Box>
                    <Typography variant="caption" color="text.secondary">Account Number</Typography>
                    <Typography variant="body1" fontWeight="600" sx={{ fontFamily: 'monospace' }}>
                      {viewingRecord.bankAccount}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">IFSC Code</Typography>
                    <Typography variant="body1" fontWeight="600" sx={{ fontFamily: 'monospace', mb: 1 }}>
                      {viewingRecord.ifscCode}
                    </Typography>
                    {viewingRecord.documents.bank.uploaded ? (
                      <>
                        <Typography variant="caption" color="text.secondary">File: {viewingRecord.documents.bank.fileName}</Typography>
                        <Box sx={{ mt: 2, display: 'flex', gap: 1 }}>
                          <Button size="small" startIcon={<ViewIcon />} variant="outlined" fullWidth>
                            View Document
                          </Button>
                          <Button size="small" startIcon={<DownloadIcon />} variant="outlined">
                            Download
                          </Button>
                        </Box>
                        {viewingRecord.documents.bank.remarks && (
                          <Alert severity={viewingRecord.documents.bank.verified ? "success" : "warning"} sx={{ mt: 2 }}>
                            {viewingRecord.documents.bank.remarks}
                          </Alert>
                        )}
                      </>
                    ) : (
                      <Alert severity="error" sx={{ mt: 1 }}>Not Uploaded</Alert>
                    )}
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 2.5, gap: 1 }}>
          <Button onClick={() => setOpenViewModal(false)}>Close</Button>
          {viewingRecord?.status === 'Pending' && (
            <>
              <Button
                variant="outlined"
                startIcon={<RejectIcon />}
                color="error"
                onClick={() => handleReject(viewingRecord)}
              >
                Reject
              </Button>
              <Button
                variant="contained"
                startIcon={<ApproveIcon />}
                onClick={() => handleApprove(viewingRecord)}
                sx={{
                  backgroundColor: 'success.main',
                  '&:hover': { backgroundColor: 'success.dark' },
                }}
              >
                Approve KYC
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>

      {/* Reject Modal */}
      <Dialog open={openRejectModal} onClose={() => setOpenRejectModal(false)} maxWidth="sm" fullWidth>
        <DialogTitle sx={{
          backgroundColor: 'error.main',
          color: 'white',
        }}>
          <Typography variant="h6" sx={{ color: 'white', display: 'flex', alignItems: 'center', gap: 1 }}>
            <WarningIcon /> Reject KYC Verification
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ mt: 2 }}>
          <Alert severity="warning" sx={{ mb: 2 }}>
            You are about to reject the KYC verification for <strong>{selectedRecord?.partnerName}</strong>.
            Please provide a reason for rejection.
          </Alert>
          <TextField
            fullWidth
            multiline
            rows={4}
            label="Rejection Remarks *"
            placeholder="Enter detailed reason for rejection (e.g., Document unclear, Information mismatch, etc.)"
            value={rejectRemarks}
            onChange={(e) => setRejectRemarks(e.target.value)}
          />
        </DialogContent>
        <DialogActions sx={{ p: 2.5, gap: 1 }}>
          <Button onClick={() => { setOpenRejectModal(false); setRejectRemarks(""); }}>Cancel</Button>
          <Button
            variant="contained"
            color="error"
            startIcon={<RejectIcon />}
            onClick={handleConfirmReject}
          >
            Confirm Rejection
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default KYCVerification;

